export const arr = [
  {
    form_id: 0,
    type: 16,
    name: "ボタン",
    label: "開始",
    cols: "0",
    init: "",
    rule: "0,required,0,0,,0,,,,,true,,,,,,,,,,,,,,,,,,,,,,,",
    color: "primary,white--text",
  },
  {
    form_id: 0,
    type: 16,
    name: "ボタン",
    label: "中断",
    cols: "0",
    init: "",
    rule:
      "0,required,true,中断開始時刻formID,true,開始:再開:終了,on:on:off,true,サブページformID,,true,,中断開始formID,date,,,,,,,,,,,,,,,,,,,,",
    color: "success,undefined",
  },
  {
    form_id: 0,
    type: 16,
    name: "ボタン",
    label: "再開",
    cols: "0",
    init: "",
    rule:
      "0,required,true,中断終了時刻formID,true,中断,on,true,サブページformID,true,true,,中断終了formID,date,,,,,,,,,,,,,,,,,,,,",
    color: "red,white--text",
  },
  {
    form_id: 0,
    type: 16,
    name: "ボタン",
    label: "終了",
    cols: "0",
    init: "",
    rule:
      "0,required,0,0,true,開始:中断:再開,on:off:on,,,,true,,,,,,,,,,,,,,,,,,,,,,,",
    color: "red,white--text",
  },
];

export default arr;
